import { useState } from 'react'

import { useMutation } from '@apollo/client'
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
} from '@mui/material'

import { CREA_INSEGNANTE, INSEGNANTI } from '../utils/api'

import { useTranslation } from 'react-i18next'

export default function TeacherDialog(props) {
    const [t] = useTranslation(['common'])
    const [name, setName] = useState('')
    const [surname, setSurname] = useState('')

    const [errorName, setErrorName] = useState(false)
    const [errorSurname, setErrorSurname] = useState(false)

    const [addTeacher] = useMutation(CREA_INSEGNANTE, {
        refetchQueries: [INSEGNANTI],
    })

    const handleChangeName = (e) => {
        setName(e.target.value)
        setErrorName(false)
    }

    const handleChangeSurname = (e) => {
        setSurname(e.target.value)
        setErrorSurname(false)
    }

    const handleClose = () => {
        setErrorName(false)
        setErrorSurname(false)
        props.setOpen(false)
    }

    const handleCloseandSend = async () => {
        if (name.length !== 0 && surname.length !== 0) {
            try {
                await addTeacher({
                    variables: { name: name, surname: surname },
                })
                props.setSnackBar('success', t('teacherdialog.teacheraddeddok'))
                props.setOpen(false)
            } catch (e) {
                console.error(e)
                if (e.message.includes('present'))
                    props.setSnackBar('error', t('teacherdialog.teacheraddeddkosamename'))
                else {
                    if (e.message.includes('not authorized'))
                        props.setSnackBar('error', t('teacherdialog.teacheraddeddnotauthorized'))
                    else
                        props.setSnackBar('error', t('teacherdialog.teacheraddeddko'))
                }
                props.setOpen(false)
            }
        } else {
            if (surname.length === 0) setErrorSurname(true)
            if (name.length === 0) setErrorName(true)
        }
    }

    return (
        <Dialog open={props.open} onClose={handleClose}>
            <DialogTitle>{t('teacherdialog.addteacher')}</DialogTitle>
            <DialogContent>
                <TextField
                    onChange={(e) => handleChangeName(e)}
                    required
                    id="name"
                    label={t('teacherdialog.teachername')}
                    fullWidth
                    variant="standard"
                    error={!!errorName}
                    helperText={errorName ? t('messages.errorrequired') : ''}
                />
                <TextField
                    onChange={(e) => handleChangeSurname(e)}
                    required
                    id="surname"
                    label={t('teacherdialog.teachersurname')}
                    fullWidth
                    variant="standard"
                    error={!!errorSurname}
                    helperText={
                        errorSurname ? t('messages.errorrequired') : ''
                    }
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>{t('button.cancel')}</Button>
                <Button onClick={handleCloseandSend} variant="contained">
                    {t('button.add')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
